module.exports = __webpack_public_path__ + "media/google_play_portrait.c20801d3.mp4";